import {
    Action,
    createReducer,
    on,
    createSelector,
    createFeatureSelector
} from '@ngrx/store';
import { Category } from '../models/category';
import * as appActions from './app-action';

export const appStateFeatureKey = 'appState';

export interface AppState {
    categories: Category[];
    subCategories: string[];
    productType: string[];
}

export const initialState: AppState = {
    categories: [],
    subCategories: [],
    productType: ['Textile', 'Other']
};

export const reducers = createReducer(
    initialState,
    on(appActions.loadCategories, (state, req) => {
        console.log(req.type, req.categories);
        state.categories = [];
        state.categories = req.categories;
        return state;
    }),
    on(appActions.loadSubCategories, (state, req) => {
        console.log(req.type, req.subCategories);
        state.subCategories = req.subCategories;
        return state;
    }),
);
